// extracted by mini-css-extract-plugin
export default {"icon":"CustomIcon_icon__XkhyZ","iconOpacity":"CustomIcon_iconOpacity__cfVdC","big":"CustomIcon_big__YsvMl"};